import {
    ADD_ADDON,
    SET_SUCCESS,
    ADD_CART_ITEMS,
    REMOVE_CART_ITEM,
    UPDATE_BOOKER,
    ACCEPT_TERMS,
    UPDATE_ITEM_GUEST,
    EMPTY_CART,
    ACTIVITY_BOOKING_NOTE_ACCEPTED,
    SET_CART_ITEM_AGENTNOTE,
    SET_CART_ITEM_CUSTOM_BOOKING,
    SET_CART_ITEM_HAS_CUSTOM_BOOKING,
    UPDATE_CART_ITEM,
    UPDATE_CART_DISCOUNT
} from './actions';
import { setCardToken } from './user';
import { doSwaggerCall } from '../hooks/useSwaggerClient';
import { describeApiError } from '../helpers/apiError';

export function emptyCart() {
    return { type: EMPTY_CART };
}

export function addCartItems(cartItems) {
    return { type: ADD_CART_ITEMS, cartItems };
}

export function acceptTermsAndConditions(accepted) {
    return { type: ACCEPT_TERMS, accepted };
}

export function updateCartDiscount(discount) {
    return { type: UPDATE_CART_DISCOUNT, discount };
}

export function removeCartItem(cartItemIndex) {
    return { type: REMOVE_CART_ITEM, cartItemIndex };
}

export function updateBooker(booker) {
    return { type: UPDATE_BOOKER, booker };
}

/**
 * Update guest data
 * @param cartitemIndex bookingCartItem index
 * @param ticketIndex ticket index in the booking cartitem
 * @param guestIndex  guest index in the ticket in the booking cartitem
 * @param guest
 * @returns {{itemIndex, guestIndex, guestIndex, guest, type: string}}
 */
export function updateItemGuest(cartitemIndex, ticketId, guestIndex, guest) {
    return { type: UPDATE_ITEM_GUEST, cartitemIndex, ticketId, guestIndex, guest };
}

export function updateCartItem(cartitemIndex, cartitem) {
    return { type: UPDATE_CART_ITEM, cartitemIndex, cartitem };
}

export function addAddon(cartItemId, addon) {
    return { type: ADD_ADDON, cartItemId, addon };
}

export function setSuccess(success) {
    return { type: SET_SUCCESS, success };
}

export function acceptBookingNote(cartitemIndex) {
    return { type: ACTIVITY_BOOKING_NOTE_ACCEPTED, cartitemIndex };
}

export function setAgentNote(cartitemIndex, agentnote) {
    return { type: SET_CART_ITEM_AGENTNOTE, cartitemIndex, agentnote };
}

export function setCustomBooking(cartitemIndex, customBooking) {
    return { type: SET_CART_ITEM_CUSTOM_BOOKING, cartitemIndex, customBooking };
}

export function setHasCustomBooking(cartitemIndex, hasCustomBooking) {
    return { type: SET_CART_ITEM_HAS_CUSTOM_BOOKING, cartitemIndex, hasCustomBooking };
}

export function confirmOrder(
    note,
    paymentIntent,
    usedPaymentMethod,
    bookingNotification,
    source_id
) {
    return (dispatch, getState) => {
        dispatch(setSuccess(null));
        const state = getState();

        // at this point we get rid of a whole bunch of unneeded data from the cart
        const trimmedCartItems = state.cart.cartItems.map(cartItem => {
            const newItem = {
                ...cartItem,
                tickets: cartItem.tickets
                    .filter(t => t.quantity !== 0)
                    .map(ticket => {
                        return {
                            ...ticket,
                            guests: ticket.guests.map(guest => {
                                // filter ids
                                const field = Object.entries(guest).filter(
                                    ([key]) => !key.includes('_postfix')
                                );
                                // create the concatenated data, to get 42 kg instead of separate fields
                                // also handle the case if we have '43 undefined' and '43 '
                                return Object.fromEntries(
                                    field.map(([key, value]) => {
                                        // Add postfix if exists
                                        if (guest[`${key}_postfix`]) {
                                            return [
                                                key,
                                                `${value} ${guest[`${key}_postfix`]}`.trim()
                                            ];
                                        }

                                        return [key, value];
                                    })
                                );
                            })
                        };
                    })
            };

            delete newItem.activity;
            delete newItem.availabilityPk; // FH-specific, not needed for backend
            return newItem;
        });

        doSwaggerCall('bookings', 'createBooking', {
            newBooking: {
                usedPaymentMethod,
                bookerData: state.cart.booker,
                guestId: state.user.customer.id,
                stripe: {
                    token: state.user.customer.stripe && state.user.customer.stripe.id
                },
                source_id,
                note,
                paymentIntent,
                notification: bookingNotification,
                cartItems: trimmedCartItems,
                discount: state.cart.discount
            }
        })
            .then(data => {
                dispatch(emptyCart());
                dispatch(setSuccess(data));
                if (data.payment_method === 'card') {
                    dispatch(setCardToken({ stripe_last4: data.last4, stripe: {} }));
                }
            })
            .catch(err => {
                // Full context in the console: the banner is short by design,
                // but whoever is looking over the guest's shoulder should see
                // the status and the raw body too.
                console.error('createBooking failed', {
                    status: err?.response?.status,
                    body: err?.response?.obj ?? err?.response?.text,
                    error: err
                });
                dispatch(setSuccess(describeApiError(err, 'Booking failed, please try again.')));
            });
    };
}
